import React, { useEffect, useState } from 'react';
import { UserPlus } from 'lucide-react';
const { friendActionState } = require('../utils/opponentActions');
export default function OpponentFriendButton({ social, username, opponent, send, error, compact = false }) {
  const state = friendActionState(social, username, opponent);
  const [pending, setPending] = useState(false);
  useEffect(() => { setPending(false); }, [social, opponent, error]);
  if (!state.label) return null;
  if (state.label==='Arkadaşın') return <span className="opponent-friend-status">Arkadaşın</span>;
  const label=state.label==='İstek gönderildi'?'Arkadaşlık isteği gönderildi':state.label;
  return <span className="inline-flex max-w-full flex-col items-start gap-1">
    <button type="button" aria-label={pending ? 'Arkadaşlık işlemi gönderiliyor' : label} title={label} disabled={state.disabled || pending}
      onClick={() => { if (send?.(state.action, opponent) !== false) setPending(true); }}
      className={`inline-flex items-center gap-1 rounded-lg border border-indigo-200 bg-indigo-50 text-indigo-800 disabled:opacity-60 ${compact ? 'p-1' : 'px-2 py-1.5 text-xs font-bold'}`}>
      <UserPlus className="h-4 w-4 shrink-0" />{!compact && (pending ? 'Gönderiliyor…' : label)}
    </button>
    {error && !compact && <span role="alert" className="text-xs text-red-700">{error}</span>}
  </span>;
}
